import { render, staticRenderFns } from "./addClassHours.vue?vue&type=template&id=21fc7d8b&scoped=true&"
import script from "./addClassHours.vue?vue&type=script&lang=js&"
export * from "./addClassHours.vue?vue&type=script&lang=js&"
import style0 from "./addClassHours.vue?vue&type=style&index=0&id=21fc7d8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc7d8b",
  null
  
)

export default component.exports